<template>
    <div class="teacher-page">
        <page-header :title="title" :items="items" />

        <div v-if="!editMode || (editMode && teacher.id)" class="row">
            <div class="col-xl-9 mb-3">
                <div class="card">
                    <div class="card-body">
                        <add-edit-form
                            v-model="teacher"
                            :edit-mode="editMode"
                            :validation="$v"
                            :server-errors="serverErrors"
                        />
                    </div>
                </div>
            </div>

            <div class="col-xl-3 mb-3">
                <div class="card">
                    <div class="card-body">
                        <div :class="{ 'mb-3': editMode }">
                            <button
                                class="btn btn-success btn-static waves-effect waves-light m-1"
                                @click="submitHandler"
                            >
                                <i class="fas fa-save" />
                                Save
                            </button>
                        </div>

                        <item-information
                            v-if="editMode"
                            :edit-mode="editMode"
                            :sections="sections"
                            :item="teacher"
                            @on-delete-confirm="onDeleteConfirm"
                        />
                    </div>
                </div>
            </div>
        </div>
        <skeleton-loader v-else />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { StatusCodes as HTTP } from 'http-status-codes';
import { required } from 'vuelidate/lib/validators';
import AddEditForm from '@/components/teachers/AddEditForm';
import ItemInformation from '@/components/elements/ItemInformation';

export default {
    page: {
        title: 'Manage Teacher'
    },

    validations: {
        teacher: {
            firstName: {
                required
            },
            lastName: {
                required
            },
            bio: {
                required
            }
        }
    },

    components: {
        AddEditForm,
        ItemInformation
    },

    data() {
        const { id = null } = this.$route.params;

        return {
            title: id ? 'Edit teacher' : 'Add teacher',
            items: [
                {
                    text: 'Aguda',
                    to: '/'
                },
                {
                    text: 'Teachers',
                    to: '/teachers'
                },
                {
                    text: id ? 'Edit' : 'Add',
                    active: true
                }
            ],
            id,
            editMode: !!id,
            teacher: {},
            serverErrors: []
        };
    },

    computed: {
        sections() {
            const sections = {};

            if (this.editMode) {
                sections.status = true;
            }

            return sections;
        }
    },

    async created() {
        if (this.editMode) {
            try {
                this.teacher = await this.getTeacher(this.id);
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    },

    methods: {
        ...mapActions({
            addTeacher: 'teachers/store',
            deleteTeacher: 'teachers/destroy',
            getTeacher: 'teachers/show',
            updateTeacher: 'teachers/update'
        }),

        async submitHandler() {
            this.serverErrors = [];

            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            try {
                if (!this.editMode) {
                    const added = await this.addTeacher(this.teacher);

                    this.$router.push(`/teachers/${added.id}/edit`);
                } else {
                    const { updatedAt } = await this.updateTeacher({
                        id: this.id,
                        data: this.teacher
                    });

                    this.teacher.updatedAt = updatedAt;

                    this.$toaster('Teacher updated!');
                }
            } catch (error) {
                const { response } = error;

                if (response) {
                    const { data, status } = response;

                    if (status === HTTP.BAD_REQUEST && data.errors) {
                        this.serverErrors = data.errors;

                        this.$toasterError('Recheck your form.');

                        return;
                    }
                }

                console.error(error);

                this.$toasterError();
            }
        },

        async onDeleteConfirm() {
            try {
                await this.deleteTeacher(this.id);

                this.$router.push('/teachers');
            } catch (error) {
                console.error(error);

                this.$toasterError();
            }
        }
    }
};
</script>
